module.exports = __webpack_public_path__ + "img/a1.cb43daa9.jpg";